import React, { useEffect, useState } from "react";
import { ReactComponent as Expand } from "../../assets/icons/expand.svg";
import PropTypes from "prop-types";
import { TicketPropsInterface } from "../../models/TicketProp";
import AppUtility from "../../assets/js/AppUtility";
import { ReactComponent as ApprovedIcon } from "../../assets/icons/approved.svg";
import { ReactComponent as YellowWaitingIcon } from "../../assets/icons/yellow-waiting.svg";
import { ReactComponent as CancelIcon } from "../../assets/icons/cancel.svg";
import { ReactComponent as RejectIcon } from "../../assets/icons/reject.svg";
import { Icon } from "@iconify/react/dist/iconify.js";
import {
  getStatusDisplayName,
  stringToTicketPhase,
  stringToTicketStatus,
  TicketPhase,
  TicketStatus,
} from "../../assets/js/FilterAppTicketConstant";

export default function TicketCard({ isExpanded = false, ticketData = null }) {
  const [colorStatus, setColorStatus] = useState("");
  const [statusTH, setStatusTH] = useState("");
  const [iconStatus, setIconStatus] = useState("");
  const [total, setTotal] = useState(ticketData.total_proposal_amount);

  const commonStatusProps = (status) => {
    switch (stringToTicketStatus(status ?? "")) {
      case TicketStatus.Rejected:
        setIconStatus(<RejectIcon className="w-6 h-6" />);
        setColorStatus("text-danger");
        break;
      case TicketStatus.Approved:
        setIconStatus(<ApprovedIcon className="w-6 h-6" />);
        setColorStatus("text-complete");
        break;
      case TicketStatus.Cancelled:
        setIconStatus(<CancelIcon className="w-6 h-6" />);
        setColorStatus("text-gray-500");
        break;
      case TicketStatus.AwaitingApproval:
      case TicketStatus.AwaitingReview:
      case TicketStatus.AwaitingOther:
        setIconStatus(<YellowWaitingIcon className="w-6 h-6" />);
        setColorStatus("text-warning");
        break;
      default:
        break;
    }
  };

  const getTotalAmount = () => {
    switch (stringToTicketPhase(ticketData.phase)) {
      case TicketPhase.Claim:
      case TicketPhase.Management:
      case TicketPhase.Accounting:
        setTotal(ticketData.total_claim_amount);
        break;
      default:
        setTotal(ticketData.total_proposal_amount);
        break;
    }
  };

  useEffect(() => {
    const init = () => {
      const displayStatus = getStatusDisplayName({
        phase: ticketData.phase,
        status: ticketData.status,
        approveSequence: {
          last_approver_sequence_no: ticketData.last_approver_sequence_no,
          next_approver_level: ticketData.next_approver_level,
          next_approver_sequence_no: ticketData.next_approver_sequence_no,
          next_approver_user_id: ticketData.next_approver_user_id,
        },
      });

      // const displayStatus =
      //   getStatusDisplayName(ticketData.phase, ticketData.status,
      //  {
      //       last_approver_sequence_no: ticketData.last_approver_sequence_no,
      //       next_approver_level: ticketData.next_approver_level,
      //       next_approver_sequence_no: ticketData.next_approver_sequence_no,
      //       next_approver_user_id: ticketData.next_approver_user_id,
      //     }) ??
      //   fallBackTicketStatus.find((ticketStatus) => {
      //     return ticketStatus.id === stringToTicketStatus(ticketData.status);
      //   });
      setStatusTH(displayStatus?.name ?? "");
      commonStatusProps(displayStatus?.id);
      getTotalAmount();
    };
    init();
  }, []);

  return (
    <div className="flex flex-col gap-y-4 bg-white lg:min-w-[700px]">
      <div className="w-full flex flex-col lg:flex-row justify-between gap-x-12 gap-y-6">
        <div className="flex flex-col gap-y-6">
          <div className="flex flex-col lg:flex-row gap-y-1 gap-x-2">
            <div className="flex">
              <div className="py-2 px-6 text-sm font-medium rounded-full bg-[#F5F5F5] cursor-default">
                # {ticketData.code}
              </div>
            </div>
            <div className="max-w-[700px] text-xl lg:text-2xl font-bold">
              {ticketData.project_name}
            </div>
          </div>

          <div className="lg:hidden border-gray-300 border-t-1" />

          <div className="flex flex-col gap-y-4 text-sm font-normal opacity-70">
            <div className="flex items-center gap-x-2">
              <div className="text-2xl">
                <Icon icon="material-symbols:account-box" />
              </div>
              <div className="flex flex-col lg:flex-row gap-x-2">
                <div>Dealer : </div>
                <div className="font-semibold text-md">
                  {ticketData.dealer_code} - {ticketData.dealer_name}
                </div>
              </div>
            </div>

            <div className="flex items-center gap-x-2">
              <div className="text-2xl">
                <Icon icon="material-symbols:featured-play-list" />
              </div>
              <div className="flex flex-col lg:flex-row gap-x-2">
                <div>ลักษณะกิจกรรม : </div>
                <div className="font-semibold text-md">
                  {ticketData.activity_name}
                </div>
              </div>
            </div>
            <div className="flex items-center gap-x-2">
              <div className="text-2xl">
                <Icon icon="material-symbols:calendar-month-rounded" />
              </div>
              <div className="flex flex-col lg:flex-row gap-x-2">
                <div>วันที่จัดกิจกรรม : </div>
                <div className="font-semibold text-md">
                  {AppUtility.displayDatetime(ticketData.event_start_date)} -{" "}
                  {AppUtility.displayDatetime(ticketData.event_end_date)}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="lg:hidden border-gray-300 border-t-1" />
        <div className="flex flex-col gap-y-4 lg:items-end">
          <div className="flex flex-row items-center gap-x-1 text-2xl font-semibold">
            <div>{iconStatus}</div>
            <div className={`${colorStatus} text-lg`}>{statusTH}</div>
          </div>
          <div className="lg:text-end">
            <p className="text-3xl">
              {Number(total).toLocaleString(undefined, {
                minimumFractionDigits: 0,
                maximumFractionDigits: 5,
              })}{" "}
              <span>THB</span>
            </p>
            <p className="text-nowrap text-md font-normal opacity-90">
              จำนวนเงินทั้งหมดก่อน VAT
            </p>
          </div>
        </div>
      </div>

      {!isExpanded && (
        <div className="flex justify-center gap-x-2 items-center">
          <p className="opacity-50 font-normal text-base underline text-nowrap">
            show sub-ticket
          </p>
          <Expand />
        </div>
      )}
    </div>
  );
}

TicketCard.propTypes = {
  isExpanded: PropTypes.bool,
  ticketData: TicketPropsInterface,
};
